import {AttrsSchema, Component} from 'panel';

import {useEventListener} from 'common/util/component-helpers';
import {keyEventSwitcher, KeyModifiers} from 'common/util/keyboard';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {SectionItem} from 'common/components/items-menu/types';

import {template} from './template';
import './index.styl';

type NavColAttrs = {
  sections: SectionItem[];
};

type NavColState = {
  searchFilter: string;
  selectedItem: string;
};

type NavColJsxProps = {
  attrs?: NavColAttrs;
};

export class NavCol extends Component<NavColState, NavColAttrs> {
  public elRefs;

  static get attrsSchema(): AttrsSchema<NavColAttrs> {
    return {
      sections: `json`,
    };
  }

  constructor() {
    super();
    this.elRefs = {};
  }

  get config() {
    return {
      template,
      routes: {
        ':item': (_, selectedItem) => ({selectedItem}),
        '': () => null,
      },
      defaultState: {
        selectedItem: ``,
        searchFilter: ``,
      },
      helpers: {
        handleItemClick: (ev) => {
          window.location.href = `#${ev.detail.item.id}`;
          // location.href change steals focus, keep focus on TOC
          this.elRefs.searchInput.focus();
        },
        handleSearchInput: (ev) => this.update({searchFilter: ev.target.value}),
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    // quick keyboard shortcut for search
    useEventListener(
      this,
      document,
      `keydown`,
      keyEventSwitcher(
        {
          [`${KeyModifiers.Alt} + KeyF`]: () => this.elRefs.searchInput.focus(),
        },
        {stopPropagation: true, usableInInputs: true},
      ),
      {capture: true},
    );
  }

  setElRef(ref, el) {
    this.elRefs[ref] = el;
  }

  getSections() {
    const selectedItem = this.state.selectedItem;
    return this.attr(`sections`).map((section) => ({
      ...section,
      items: section.items.map((item) => ({
        ...item,
        isSelected: item.id === selectedItem,
      })),
    }));
  }
}

export const NavColEl = defineAndMakeJsxFactory<NavColJsxProps>(`nav-col`, NavCol);
